import 'moment/locale/pt-br';
import 'antd/dist/antd.css';
import './styles/tailwind.css';
import './styles/customLibs/pageLoaderCustom.css';
import 'swiper/swiper.scss';
import 'swiper/components/pagination/pagination.scss';
import './styles/customLibs/swiperCustom.scss';
import './styles/customLibs/antdCustom.scss';

import { ConfigProvider } from 'antd';
import locale from 'antd/lib/locale/pt_BR';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthContextProvider } from './context/AuthContext';
import { SidebarCollapseContextProvider } from './context/SidebarCollapseContext';
import { Routes } from './routes';
import { GlobalStyles } from './styles/global';

function App() {
  return (
    <ConfigProvider locale={locale}>
      <AuthContextProvider>
        <SidebarCollapseContextProvider>
          <Router>
            <GlobalStyles />
            <Routes />
          </Router>
        </SidebarCollapseContextProvider>
      </AuthContextProvider>
    </ConfigProvider>
  );
}

export default App;
